export default "Simulez en 2 minutes vos aides MaPrimeRénov’, CEE, éco-PTZ et TVA 5,5 %. Résultat personnalisé selon votre logement et vos revenus. Sans inscription.";
